import React from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./welcomeBonusPop.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getWelcomeBonus } from "../../../lib/store/actions";
import loader from "../../../assets/images/loading.gif";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

const WelcomeBonusPop = ({
  showWelcomeBonus,
  setShowWelcomeBonus,
  showClaimBonus,
  setShowClaimBonus,
  id,
  onFinish,
}) => {
  // const { t } = useTranslation();
  const t = useLanguage();
  const dispatch = useDispatch();
  const { welcomeBonusLoading } = useSelector(({ Auth }) => Auth);

  const handledHide = () => {
    setShowWelcomeBonus(!showWelcomeBonus);
    onFinish();
  };

  const handlePopUp = () => {
    const audio = new Audio("https://sound.bitanicagames.com/claim.mp3");

    // Play the audio
    audio.play().catch((error) => {
      console.error("Error playing audio:", error);
    });

    dispatch(
      getWelcomeBonus({
        data: { _id: id },
        callBack: (err, res) => {
          if (err) {
            return;
          }
          // console.info(res, "RESPONSEEEEEEEEE");
          if (res) {
            setShowClaimBonus(true);
            setShowWelcomeBonus(false);
          }
        },
      })
    );
  };

  return (
    <>
      <Modal
        show={showWelcomeBonus}
        // onHide={handledHide}
        backdrop="true"
        centered
        className={`${styles.buyPop} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body>
            <Button
              onClick={handledHide}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div className="top text-center pt-4">
              <h3
                className="m-0 text-white d-inline-block pb-1 fw-bold"
                // style={{ borderBottom: "1px solid #02ADEA" }}
              >
                {t("welcomebonus_pop.title")}
              </h3>
            </div>

            <div className="text-center">
              <div className="py-2">
                <img
                  src="https://sound.bitanicagames.com/welcomebox.gif"
                  className="img-fluid object-contain"
                  style={{ height: 350 }}
                  alt=""
                />
              </div>
            </div>
            <div className=" text-center pb-3" style={{ marginTop: -30 }}>
              <Button
                onClick={() => handlePopUp()}
                style={{ maxWidth: 171 }}
                className="d-inline-flex text-uppercase align-items-center justify-content-center fw-bold commonBtn border-0"
              >
                {welcomeBonusLoading ? (
                  <img
                    src={loader}
                    alt=""
                    className="img-fluid object-fit-contain"
                    style={{ height: 20 }}
                  />
                ) : (
                  t("welcomebonus_pop.open")
                )}
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default WelcomeBonusPop;
